module.exports = __webpack_public_path__ + "media/discover-background.f1eb8aa6.mp4";